export enum CountryId {
  CZE = 1,
  AFG = 468,
  ALB = 469,
  DZA = 470,
  ASM = 471,
  VIR = 472,
  AND = 473,
  AGO = 474,
  AIA = 475,
  ATA = 476,
  ATG = 477,
  ARG = 478,
  ARM = 479,
  ABW = 480,
  AUS = 481,
  BHS = 483,
  BHR = 484,
  BGD = 485,
  BRB = 486,
  BEL = 487,
  BLZ = 488,
  BLR = 489,
  BEN = 490,
  BMU = 491,
  BTN = 492,
  BOL = 493,
  BIH = 494,
  BWA = 495,
  BVT = 496,
  BRA = 497,
  IOT = 498,
  VGB = 499,
  BRN = 500,
  BGR = 501,
  BFA = 502,
  BDI = 503,
  COK = 504,
  CHN = 506,
  DNK = 507,
  DMA = 508,
  DOM = 509,
  DJI = 510,
  TCD = 511,
  EGY = 512,
  ECU = 513,
  ERI = 514,
  EST = 515,
  ETH = 516,
  FRO = 517,
  FLK = 518,
  FJI = 519,
  PHL = 520,
  FIN = 521,
  FRA = 522,
  GAB = 523,
  GMB = 524,
  GHA = 525,
  GIB = 526,
  GRD = 527,
  GRL = 528,
  GEO = 529,
  GUM = 530,
  GTM = 531,
  GIN = 532,
  GNB = 533,
  GUY = 534,
  HTI = 535,
  HMD = 536,
  HND = 537,
  HKG = 538,
  CHL = 539,
  HRV = 540,
  IND = 541,
  IDN = 542,
  IRQ = 543,
  IRN = 544,
  IRL = 545,
  ISL = 546,
  ITA = 547,
  ISR = 548,
  JAM = 549,
  JPN = 550,
  YEM = 551,
  ZAF = 552,
  SGS = 553,
  JOR = 554,
  /** @deprecated */
  YUG = 555,
  CYM = 556,
  KHM = 557,
  CMR = 558,
  CAN = 559,
  CPV = 560,
  QAT = 561,
  KAZ = 562,
  KEN = 563,
  KIR = 564,
  CCK = 565,
  COL = 566,
  COM = 567,
  COG = 568,
  COD = 569,
  PRK = 570,
  KOR = 571,
  CRI = 572,
  CUB = 573,
  KWT = 574,
  CYP = 575,
  KGZ = 576,
  LAO = 577,
  LSO = 578,
  LBN = 579,
  LBR = 580,
  LBY = 581,
  LIE = 582,
  LTU = 583,
  LVA = 584,
  LUX = 585,
  MAC = 586,
  MDG = 587,
  HUN = 588,
  MKD = 589,
  MYS = 590,
  MWI = 591,
  MDV = 592,
  MLI = 593,
  MLT = 594,
  MAR = 595,
  MHL = 596,
  MUS = 597,
  MRT = 598,
  UMI = 599,
  MEX = 600,
  FSM = 601,
  MDA = 602,
  MCO = 603,
  MNG = 604,
  MSR = 605,
  MOZ = 606,
  MMR = 607,
  NAM = 608,
  NRU = 609,
  DEU = 610,
  NPL = 611,
  NER = 612,
  NGA = 613,
  NIC = 614,
  NIU = 615,
  NLD = 617,
  NFK = 618,
  NOR = 619,
  NZL = 620,
  OMN = 621,
  PAK = 622,
  PLW = 623,
  PAN = 624,
  PNG = 625,
  PRY = 626,
  PER = 627,
  PCN = 628,
  CIV = 629,
  POL = 630,
  PRI = 631,
  PRT = 632,
  AUT = 633,
  GNQ = 634,
  ROU = 635,
  RUS = 636,
  RWA = 637,
  GRC = 638,
  SLV = 639,
  WSM = 640,
  SMR = 641,
  SAU = 642,
  SEN = 643,
  MNP = 644,
  SYC = 645,
  SLE = 646,
  SGP = 647,
  SVK = 648,
  SVN = 649,
  SOM = 650,
  ARE = 651,
  USA = 652,
  LKA = 653,
  CAF = 654,
  SDN = 655,
  SUR = 656,
  SJM = 657,
  SHN = 658,
  LCA = 659,
  KNA = 660,
  STP = 661,
  VCT = 662,
  SWZ = 663,
  SYR = 664,
  SLB = 665,
  ESP = 666,
  SWE = 667,
  CHE = 668,
  TJK = 669,
  TZA = 670,
  THA = 671,
  TWN = 672,
  TGO = 673,
  TKL = 674,
  TON = 675,
  TTO = 676,
  TUN = 677,
  TUR = 678,
  TKM = 679,
  TCA = 680,
  TUV = 681,
  UGA = 682,
  UKR = 683,
  URY = 684,
  UZB = 685,
  CXR = 686,
  VUT = 687,
  VAT = 688,
  GBR = 689,
  VEN = 690,
  VNM = 691,
  TLS = 692,
  ZMB = 693,
  ESH = 694,
  ZWE = 695,
  MNE = 696,
  XKX = 701,
  SRB = 706,
  AZE = 707,
  ALA = 708,
  BES = 710,
  CUW = 712,
  GUF = 714,
  PYF = 716,
  ATF = 718,
  GLP = 720,
  GGY = 722,
  IMN = 724,
  JEY = 726,
  MTQ = 728,
  MYT = 730,
  NCL = 732,
  PSE = 734,
  REU = 736,
  BLM = 738,
  MAF = 740,
  SPM = 742,
  SXM = 744,
  SSD = 746,
  WLF = 750,
  PSX = 751,
}
